import Layout from '@/apps/layout/components'
import RecommendToKnow from '@/apps/RecommendToKnow'
import React from 'react'

const RecommendToKnowPage = (): React.ReactElement => {
  return (
    <Layout>
      <RecommendToKnow />
    </Layout>
  )
}

export default RecommendToKnowPage
